import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { RPESubActividad } from './rpe-sub-actividades.model';

@Injectable({
  providedIn: 'root'
})
export class RPESubActividadesService {
  url: string;  
  endpoint = 'rpeSubActividades';

  constructor(private http: HttpClient) {}

  addRPESubActividades(rpeSubActividades: RPESubActividad[]): Observable<RPESubActividad[]> {
    return this.http.post<RPESubActividad[]>(`${this.url}/${this.endpoint}/`, {
      'rpesubactividades': rpeSubActividades
    }
    );
  }  
  
}
